// Lo que el shell MOBILE (`ShellMobile`, App.tsx) comparte con sus pantallas: si la cuenta
// ve la interfaz nueva y cómo abrir el sheet de destinos
// (ADR-2026-10-08-la-interfaz-nueva-llega-al-telefono).
//
// En escritorio eso lo da el contexto del shell (`useCuentaShell().uiNueva`), pero en el
// teléfono ese shell no está montado y su contexto devolvía siempre `false`: el grupo C
// veía la interfaz de siempre. El grupo se resuelve UNA vez en `ShellMobile` y viaja por
// acá, así la home, la barra y el sheet no pueden discrepar.

import { createContext, useContext } from 'react';
import { useCuentaShell } from '../../estilos/EstiloMinimal';
import type { EdicionSheet, ModoSheet } from './SheetGenerar';

/** Dónde abre el sheet: el paso de los destinos (`null`) o una sección ya elegida. */
export type SeccionDelSheet = null | 'redes' | 'catalogo' | 'herramientas';

interface ShellMobileCtx {
  uiNueva: boolean;
  /** Abre el sheet de destinos. `null` fuera del shell mobile. */
  abrirSheet: ((seccion: SeccionDelSheet) => void) | null;
  /**
   * Las herramientas (ediciones rápidas + modos de Herramientas), ya con candado y destino:
   * las MISMAS del sheet, para la sección de la home. `null` fuera del shell mobile.
   */
  herramientas: { ediciones: EdicionSheet[]; modos: ModoSheet[] } | null;
}

export const ShellMobileContext = createContext<ShellMobileCtx>({ uiNueva: false, abrirSheet: null, herramientas: null });

export function useShellMobile(): ShellMobileCtx {
  return useContext(ShellMobileContext);
}

/**
 * ¿Esta cuenta ve la interfaz nueva? En escritorio lo dice el shell de escritorio; en el
 * teléfono, el mobile. Fuera de los dos, `false` (la interfaz de siempre).
 */
export function useUiNueva(): boolean {
  const escritorio = useCuentaShell();
  const mobile = useShellMobile();
  return escritorio.dentroDelShell ? escritorio.uiNueva : mobile.uiNueva;
}
